<script setup lang="ts">
import { PHONES } from "@/constants/phones";
import { useApplicationStore } from "@/stores/application";

const store = useApplicationStore();

</script>

<template>
    <div class="row">
        <div class="col-12 mt-1 bg-image-animate-ten chalet mb-3">
            <h3 class="col-lg-12 col-md-12 mt-5 mb-4 blue font-weight-bold">
                Thank you. Your application form has been submitted to Legal &amp; General.
            </h3>
            <p class="col-lg-6 col-md-12">
                Our friendly customer service team are available from 9am - 5pm Monday to Friday.
            </p>
            <p class="lead col-lg-6 col-md-12 py-2">
                Next steps
            </p>
            <div class="col-lg-6 col-md-12 ml-4">
                <ul>
                    <li>You will receive a welcome email/letter from Legal &amp; General within 5 days (excluding weekends and bank holidays).</li>
                    <li>You have a 30 day 'cooling off period' from the date of submitting your application to cancel.</li>
                    <li>
                        Once the 30 days have expired and the policy has started, you will not be able to change or cancel your plan. Please refer to the
                        <a
                            :href="store.keyFeaturesUrl"
                            target="_blank"
                        >key features</a> &amp;
                        <a
                            :href="store.termsConditionsUrl"
                            target="_blank"
                        >terms and conditions</a> for more information.
                    </li>
                    <li>Please note the value of the investments that make up your pension savings are not guaranteed and can go up and down daily. The value of your pension savings will affect the amount of income you receive.</li>
                    <li>Legal &amp; General will ask the relevant pension provider or Legal &amp; General team to start releasing your pension savings on or around your selected retirement date.</li>
                    <li>If you have requested a tax-free lump sum, this will be paid to you, then the remaining amount will be used for your annuity purchase.</li>
                    <li>Once Legal &amp; General have received all the funds, they will put your annuity into payment. Payments will be made direct into your nominated bank account.</li>
                    <li>Once your annuity is set up, Legal &amp; General will send you your policy documents.</li>
                </ul>
            </div>
            <p class="col-lg-12 col-md-12">
                If you have any questions about your application, please contact Legal &amp; General's customer call centre on
                <a :href="`tel:${PHONES.CUSTOMER_CALL_CENTER}`">{{ PHONES.CUSTOMER_CALL_CENTER }}.</a>
            </p>
            <p class="col-lg-12 col-md-12">
                Lines are open 9am to 5pm, Monday to Friday. Calls may be recorded and monitored.
            </p>
        </div>
    </div>
</template>
